export const routes = {
  helpCenter: '/central-de-ajuda',
  search: (search?: string, page?: string) => {
    let pageUrl = `/busca?q=${search}`;

    if (page) {
      pageUrl = `${pageUrl}&pagina=${page}`;
    }

    return pageUrl;
  },
  ESGCommitment: '/compromissos-asg',
  ESGCommitmentCategory: (category: string) => `/compromissos-asg/${category}`,
  ESGCommitmentSubCategory: (category: string, subCategory: string) =>
    `/compromissos-asg/${category}/${subCategory}`,
  helpCenterCategory: (category: string) => `/central-de-ajuda/categorias/${category}`,
  helpCenterSubject: (category: string, subject: string) =>
    `/central-de-ajuda/categorias/${category}/${subject}`,
  helpCenterAnswer: (category: string, answer: string) => `/central-de-ajuda/${category}/${answer}`,
  helpCenterSearch: (search?: string) => `/central-de-ajuda/busca?search=${search}`,
  insuranceCategory: (category: string) => `/seguros/${category}`,
  insuranceSubCategory: (category: string, subCategory: string) =>
    `/seguros/${category}/${subCategory}`,
  insuranceProduct: (category: string, subCategory: string, product: string[]) =>
    `/seguros/${category}/${subCategory}/${product.join('/')}`,
  getToKnowAxa: '/conheca-a-axa',
  brokers: '/para-corretores'
};
